import React from 'react';
import Shop3 from '../../components/ShopElements/Shop3';
import PageHeader from '../Shared/PageHeader';

const Shop3Col = () => {
    return (
        <div>
            <PageHeader title="Shop" />
            <Shop3 />

        </div>
    );
};

export default Shop3Col;